/* global window */
import React, { useCallback, useContext, useEffect } from 'react';
import '../styles/TopHeaderBar.css';
import AppContext from './context/AppContext';
import { Link } from 'react-router-dom';
import { CustomerContext } from './context/CustomerContext';
import { FaLock, FaUser } from 'react-icons/fa';
const ROLLING_TEXT_INTERVAL = 4000; // 4 seconds
const ROLLING_TEXT_MAX_HEIGHT = 300; // Maximum height for the rolling text


const TopHeaderBar = () => {
    const { customerData } = useContext(CustomerContext);
    const { appContext } = useContext(AppContext);
    const appConfig = appContext.config.themeConfig;
    const [translateY, setTranslateY] = React.useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setTranslateY((prev) => (prev - 100) % ROLLING_TEXT_MAX_HEIGHT);
        }, ROLLING_TEXT_INTERVAL);
        return () => clearInterval(interval);
    }, []);

    const navigateToLogin = useCallback(() => {
        window.location.assign('/login');
    }, []);

    return (
        <div
            className={'d-flex justify-content-center align-items-start top-header-bar--outer-container'}>
            <div
                className={'top-header-bar--inner-container px-2'}>
                <div
                    className={'top-header-bar--rolling-text desktop-only'}>
                    {appConfig.headerRollingTexts.map((text) => (
                        <div
                            key={`rolling-text-${text}`}
                            style={{
                                transform: `translateY(${translateY}%)`,
                                transition: 'transform 0.1s ease-in-out',
                            }}
                            className={'top-header-bar--rolling-text-item'}
                        >
                            {text}
                        </div>
                    ))}
                </div>
                <div
                    className={'announcement-bar'}>
                    {appContext.config.storefrontAnnouncement}
                </div>
                <div
                    className={'top-header-bar--account-links d-flex gap-4 desktop-only'}>
                    {(!customerData || Object.keys(customerData).length === 0) ? (
                        <>
                            <Link
                                onClick={navigateToLogin}
                                to={'#'}
                            >
                                <FaLock
                                    size={15}
                                /> Sign In
                            </Link>
                            <span
                                className={'nav-separator'}>{' | '}</span>
                        </>
                    ) : null}
                    <Link
                        style={{
                            marginLeft: '15px',
                        }}
                        to={'/myaccount.asp'}
                    >
                        <FaUser
                            size={15}
                        /> My Account
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default TopHeaderBar; 